import { Box, Button, CircularProgress, IconButton, TextField, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { apiGatewayAxiosInstance } from "../../utils/axios";

import { useNavigate } from "react-router-dom";
import AlertMessageComponent from "../../pages/components/AlertMessageComponent";

export default function Setup2FA({ userEmail }) {
    const [qrCode, setQrCode] = useState("");
    const [secret, setSecret] = useState("");
    const [token, setToken] = useState("");
    const [verificationResult, setVerificationResult] = useState(null);

    const [error, setError] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [showQrSection, setShowQrSection] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetch2faSecret() {
            try {
                const response = await apiGatewayAxiosInstance.post(
                    "/user_management/2fa/setup",
                    { email: userEmail },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    },
                );

                if (response.status === 200) {
                    const data = response.data;
                    setQrCode(data.qrCodeDataUrl);
                    setSecret(data.secret);
                    setShowQrSection(true);
                }
            } catch (err) {
                const message = err?.response?.data?.message || err?.message || "Something went wrong. Please try again later.";

                setError(message);
                setShowAlert(true);
                setShowQrSection(false);
            }
        }
        if (userEmail) {
            fetch2faSecret();
        } else {
            navigate("/auth/login");
        }
    }, [userEmail]);

    async function verifyToken() {
        try {
            const response = await apiGatewayAxiosInstance.post(
                "/user_management/2fa/verify",
                { token, email: userEmail },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );
            if (response.status === 200) {
                setVerificationResult(response.data.data);

                setTimeout(() => {
                    navigate("/auth/login");
                }, 1000); // 1000 milliseconds = 1 second
            } else {
                setVerificationResult(response.data.data);
            }
        } catch (err) {
            const message = err?.response?.data?.data || err?.message || "Something went wrong. Please try again later.";
            setError(message);
            setShowAlert(true);

        }
    }

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    return (
        <Box
            sx={{
                maxWidth: 500,
                mx: "auto",
                mt: 6,
                p: 4,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: 1,
                backgroundColor: "#fafafa",
            }}
        >
            {/* QR Section */}
            {showQrSection ? (
                qrCode ? (
                    <>
                        <Typography variant="body2" align="center" sx={{ mb: 2 }}>
                            Scan QR Code With Your Authenticator App
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                mb: 3,
                            }}
                        >
                            <img src={qrCode} alt="Scan this QR code with your authenticator app" style={{ maxWidth: "100%", height: "auto" }} />
                        </Box>

                        <Typography variant="body2" align="center" sx={{ mb: 2 }}>
                            Or Enter This Secret Manually:-
                            <Box component="span" sx={{ fontWeight: 600, ml: 1, wordBreak: "break-all" }}>
                                {secret}
                            </Box>
                        </Typography>

                        <TextField
                            label="Enter 6-digit code to complete verification"
                            variant="outlined"
                            value={token}
                            onChange={e => setToken(e.target.value)}
                            inputProps={{
                                maxLength: 6,
                                style: { letterSpacing: "0.3em", textAlign: "center" },
                            }}
                            fullWidth
                            sx={{ mb: 2 }}
                        />

                        <Button variant="contained" color="primary" fullWidth onClick={verifyToken} disabled={token.length !== 6}>
                            Verify
                        </Button>

                        {verificationResult && (
                            <Typography
                                variant="body2"
                                align="center"
                                sx={{
                                    mt: 2,
                                    color: verificationResult.includes("Invalid") ? "error.main" : "success.main",
                                }}
                            >
                                {verificationResult}
                            </Typography>
                        )}
                    </>
                ) : (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                        <CircularProgress />
                    </Box>
                )
            ) : (
                <></>
            )}

            {/* Error alert */}
            <AlertMessageComponent message={error} fieldName="2faError" handleClose={handleCloseAlert} show={showAlert} />
        </Box>
    );
}
